/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.alert-success\":\"Green circle with checkmark\"}");